import { Loc } from 'main.core';
import { NoticeBase } from 'b24network.vue.cross-scenario-shared-js';

/**
 * Any case when Oauth2 failed with error
 */
export class OauthFailed extends NoticeBase
{
	constructor()
	{
		super(
			Loc.getMessage('EXT_B24NET_LOGGING_IN_CHECK_INET_AND_TRY_AGAIN', { '[br]': '<br>' }),
			Loc.getMessage('EXT_B24NET_LOGGING_IN_CANT_ENTER_B24'),
		);
	}
}
